import { Link, NavLink } from 'react-router-dom';

import { LocationDescriptorObject } from 'history';
import React from 'react';
import { TBaseButtonOrLinkProps } from './BaseButtonOrLink.types';

export const BaseButtonOrLink: React.FC<TBaseButtonOrLinkProps> = ({
  className,
  type = 'button',
  disabled = false,
  children,
  isNavLink,
  to,
  onClick,
  form,
  target,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let Component: any = 'button';
  const rest = {};

  if (to) {
    let isExternalLink = false;

    if (typeof to === 'string') {
      isExternalLink = to.includes('://') || to.includes('mailto');
    } else if ((to as LocationDescriptorObject).pathname) {
      isExternalLink = (to as LocationDescriptorObject).pathname!.includes('://');
    }

    if (isExternalLink) {
      Component = 'a';
      Object.assign(rest, {
        href: to,
        target,
        ...(target === '_blank' && { rel: 'noopener noreferrer' }),
      });
    } else {
      Component = isNavLink ? NavLink : Link;
      Object.assign(rest, {
        to,
      });
    }
  }

  return (
    <Component
      className={className}
      onClick={onClick}
      type={type}
      disabled={disabled}
      form={form}
      {...rest}>
      {children}
    </Component>
  );
};
